module.exports = __webpack_public_path__ + "img/thumbnail_MalayanTapir_m_albino.440f0897.png";